export const useZonePrefix = (scope: string, tabName: string) => {
  return `${scope}__${tabName}`;
};
